import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { teamMember } from "querypieces";
import { sortAlphaProp} from "helpers";

// Craft 5.11 returns an empty Categories field for Neo blocks reached through
// `children` (its maintainHierarchy hook loses the ids once the GraphQL resolver
// adds the category-group filter). The same blocks fetched flat with
// `pageBuilder(level: 2)` resolve correctly, so the team type of each block is
// read from there. `limit: 1` keeps Apollo from storing this under the same cache
// key as the empty `teamType` that the page query writes for these blocks.
const query = gql`
  query($entryId: [QueryArgument]) {
    teams: entries(section: "team") {
      ${teamMember}
    }
    teamTypes: categories(group: "teamMemberTypes") {
      id
      title
    }
    teamTypeBlocks: entry(id: $entryId) {
      id
      ...on page_Entry {
        pageBuilder(level: 2) {
          ...on pageBuilder_teamType_BlockType {
            id
            teamType(limit: 1) {
              id
            }
          }
        }
      }
    }
  }
`;

const useTeams = (entryId) => {
  const { loading, error, data } = useQuery(query, {
    variables: { entryId: entryId ? [entryId] : null }
  });

  return {
    loading,
    error,
    data: data ? selectTeam(data) : data
  };
};

export default useTeams;

const selectTeam = ({ teams, teamTypes, teamTypeBlocks }) => {
  const teamMembers = teamTypes.map(({ id, title }) => {
    const membersInTeam = teams
      .filter(d => d.teamType?.[0]?.id === id)



    return {
      id,
      title,
      members: sortAlphaProp(membersInTeam,"lastName")
    };
  });

  const teamTypeByBlockId = {};
  (teamTypeBlocks?.pageBuilder || []).forEach(block => {
    if (block.id && block.teamType?.[0]) {
      teamTypeByBlockId[block.id] = block.teamType[0].id;
    }
  });

  return {
    teamMembers,
    teamTypeByBlockId
  };
};
